<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="unidadesReguladoras"
                    :validations="validations.unidadeReguladora"
                    label="Unidade reguladora"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeReguladoraId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :options="infraestruturasReguladoras"
                    :validations="validations.infraestruturaReguladora"
                    label="Local de atendimento regulador"
                    show-default-option
                    text-field="nome"
                    v-model="model.infraestruturaReguladoraId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-button
                    :label="false"
                    @click="$refs.Form.validate(add)"
                    color="primary"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

// Enums.
import reguladorTipo from '@/enums/regulacao/reguladorTipo'

export default {
    computed: {
        validations() {

            return {
                unidadeReguladora: { required: true },
                infraestruturaReguladora: { required: true },
            }
        },
        unidadesReguladoras() {

            const unidadesReguladoras = []

            this.data.model.reguladores
                .filter(r => r.ativo
                    && (r.tipoId === this.enums.reguladorTipo.MUNICIPAL || (
                        r.tipoId === this.enums.reguladorTipo.LOCAL_ATENDIMENTO
                            && r.infraestruturaId === this.solicitante.infraestruturaId
                    ))
                    && !this.infraestruturasReguladorasDoSolicitanteIds.includes(r.infraestruturaId)
                )
                .forEach(regulador => {

                    if (!unidadesReguladoras.find(u => u.id === regulador.unidadeId)) {

                        unidadesReguladoras.push({
                            id: regulador.unidadeId,
                            nomeFantasia: regulador.unidadeNomeFantasia,
                        })
                    }
                })

            return unidadesReguladoras.sort((a, b) => a.nomeFantasia.localeCompare(b.nomeFantasia))
        },
        infraestruturasReguladoras() {

            if (!this.model.unidadeReguladoraId) {

                return []
            }

            return this.data.model.reguladores
                .filter(r => r.ativo
                    && r.unidadeId === this.model.unidadeReguladoraId
                    && (r.tipoId === this.enums.reguladorTipo.MUNICIPAL || (
                        r.tipoId === this.enums.reguladorTipo.LOCAL_ATENDIMENTO
                            && r.infraestruturaId === this.solicitante.infraestruturaId
                    ))
                    && !this.infraestruturasReguladorasDoSolicitanteIds.includes(r.infraestruturaId))
                .map(regulador => ({
                    id: regulador.infraestruturaId,
                    nome: regulador.infraestruturaNome,
                }))
                .sort((a, b) => a.nome.localeCompare(b.nome))
        },
        infraestruturasReguladorasDoSolicitanteIds() {

            return this.solicitante.reguladores.map(r => r.infraestruturaId)
        }
    },
    data: () => ({
        model: {
            unidadeReguladoraId: null,
            infraestruturaReguladoraId: null,
        },
        enums: { reguladorTipo },
    }),
    methods: {
        add() {

            const regulador = this.getRegulador()

            this.solicitante.reguladores.push({
                id: regulador.id,
                unidadeNomeFantasia: regulador.unidadeNomeFantasia,
                infraestruturaId: regulador.infraestruturaId,
                infraestruturaNome: regulador.infraestruturaNome,
                exames: [],
                procedimentosCirurgicos: [],
                especialidades: [],
                hasSolicitacao: false,
            })

            this.resetForm()
        },
        getRegulador() {

            return this.data.model.reguladores.find(r => r.infraestruturaId === this.model.infraestruturaReguladoraId)
        },
        resetForm() {

            this.model.unidadeReguladoraId = null
            this.model.infraestruturaReguladoraId = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
        solicitante: { type: Object, required: true },
    },
    watch: {
        'model.unidadeReguladoraId'() {

            this.model.infraestruturaReguladoraId = null
        },
        infraestruturasReguladoras(infraestruturasReguladoras) {

            if (infraestruturasReguladoras.length === 1) {

                this.model.infraestruturaReguladoraId = infraestruturasReguladoras[0].id
            }
        }
    }
}
</script>